import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import AddressMismatchModal from '../components/addressMismatch/AddressMismatchModal'
import * as actions from '../actions'

export const AddressMismatchContainer = ({
  addressMismatch = {},
  getOrderServices,
  fxbuyflowSessionId,
  ...props
}) => {
  const [modalVisible, setModalVisible] = useState(
    !!addressMismatch.showAddressMismatchModal
  )

  useEffect(() => {
    setModalVisible(!!addressMismatch.showAddressMismatchModal)
  }, [addressMismatch.showAddressMismatchModal])

  const handleCloseModal = () => {
    setModalVisible(false)
  }

  return (
    modalVisible && (
      <AddressMismatchModal
        visible={modalVisible}
        onCancel={handleCloseModal}
        addressMismatchOptions={addressMismatch.addressMismatchOptions || []}
        getOrderServices={getOrderServices}
        fxbuyflowSessionId={fxbuyflowSessionId}
        {...props}
      />
    )
  )
}

AddressMismatchContainer.propTypes = {
  addressMismatch: PropTypes.object,
  getOrderServices: PropTypes.func.isRequired,
  fxbuyflowSessionId: PropTypes.string
}

export const mapStateToProps = state => ({
  addressMismatch: state.session.addressMismatch,
  fxbuyflowSessionId: state.session?.fxbuyflowSessionId
})

export const mapDispatchToProps = {
  getOrderServices: actions.getOrderServices
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddressMismatchContainer)